import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { ErrorResponse } from '../../models/error.model';
import { Notification, NotificationResponse, NotificationUnreadResponse } from '../../models/notification.model';
import { authToken } from '../../scripts/authentication.script';
import { MessageResponse } from '../../models/message.model';

export class ApiDigitalAdminNotification {
  static apiResponse: ApiResponse

  public static async getNotifications(
    page: number,
    limit: number,
    status: string,
    category: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let notificationResponse: NotificationResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/notifications.data.json').then(response => { notificationResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (notificationResponse!.data && 'items' in notificationResponse!.data && Array.isArray(notificationResponse!.data.items)) {
        let items: Notification[] = notificationResponse!.data.items

        if (status) {
          items = items.filter(item => item.status === status)
        }
        if (category) {
          items = items.filter(item => item.category === category)
        }

        notificationResponse!.data.items = items

        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: notificationResponse!.success === true ? notificationResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/notifications?page=${page}&limit=${limit}&status=${status}&category=${category}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then( response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch( error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async getNotificationsUnread(
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let notificationUnreadResponse: NotificationUnreadResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/notifications.unread.data.json').then(response => { notificationUnreadResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (notificationUnreadResponse!.success) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: notificationUnreadResponse!.success === true ? notificationUnreadResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/notifications/unread-count`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then( response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch( error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async putNotificationRead(
    id_notification: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let notifications: Notification[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/notifications.data.json').then(response => { notifications = response.data.data.items }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (notifications!.some(item => item.id === id_notification)) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/notifications/${id_notification}/read`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.put(url, null, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch( error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async putNotificationReadAll(
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (messageResponse!.success) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/notifications/read-all`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.put(url, null, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch( error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async putNotificationArchive(
    id_notification: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let notifications: Notification[] | null = null
      let messageResponse: MessageResponse | null = null
      let errorResponse: ErrorResponse | null = null

      await axios.get('../../../../../database/notifications.data.json').then(response => { notifications = response.data.data.items }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { messageResponse = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { errorResponse = response.data }).catch(error => { alert(error) })

      if (notifications!.some(item => item.id === id_notification)) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: messageResponse!.success === true ? messageResponse!.data : null
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: errorResponse!.success === false ? errorResponse!.error : null 
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/notifications/${id_notification}/archive`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.put(url, null, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch( error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }
}
